var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowForwardUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.293 1.29289C17.6835 0.902369 18.3165 0.902369 18.707 1.29289L22.707 5.29289C23.0975 5.68342 23.0975 6.31645 22.707 6.70696L18.707 10.707C18.3165 11.0974 17.6835 11.0974 17.293 10.707C16.9025 10.3165 16.9025 9.68342 17.293 9.29289L19.5859 6.99992H9C5.68629 6.99993 3 9.68622 3 12.9999C3.00004 16.3136 5.68632 18.9999 9 18.9999H15C15.5523 18.9999 16 19.4476 16 19.9999C16 20.5522 15.5523 20.9999 15 20.9999H9C4.58175 20.9999 1.00004 17.4182 1 12.9999C1 8.58165 4.58172 4.99992 9 4.99992H19.5859L17.293 2.70696C16.9025 2.31646 16.9025 1.68342 17.293 1.29289Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowForwardUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconArrowForwardUp.5801b16186667f4a222dc33b88476eac.svg";